// extracted by mini-css-extract-plugin
export var modal = "_sv-0";
export var table = "_sv-1";